import { ButtonEmpty, Icon } from '@tallink/components-lib'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

import s from './LinkAddVoucher.module.scss'

export default function LinkAddVoucher({ onClick }) {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <div className={s['link-add-voucher']}>
      <Icon size="l" type="discount-coupon" />
      <ButtonEmpty className={s.link} onClick={handleClick}>
        {t('voucherPanel.link.addVoucher')} →
      </ButtonEmpty>
    </div>
  )

  function handleClick() {
    if (onClick) onClick()
    else history.push('/voucher')
  }
}

LinkAddVoucher.propTypes = {
  onClick: PropTypes.func
}
